module.exports = __webpack_public_path__ + "img/jb.c86e5ebe.jpeg";